import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { SelectListItemModel } from 'models/SelectList';
import { ProductService } from 'services/product.service';
import { ProductPlanTagConstants } from 'constants/ProductPlanTagConstants';
import { ProductVariantModel } from 'models/generated/Entities.GormCrm.ProductVariant';
import { Inputs } from 'modules/inputs';
import { BrandService } from 'services/brand.service';

@Component({
	selector: 'new-domain-product-plan-input',
	templateUrl: './new-domain-product-plan-input.component.html',
	imports: [FormsModule, Layout, Inputs, TranslatePipe]
})
export class NewDomainProductPlanInputComponent {

	isTldDk = false;
	availableVariants: SelectListItemModel[] = [];
	brands: SelectListItemModel[] = [];
	price?: number;
	brandId?: string;

	@Input()
	set domainName(value: string | undefined) {
		if (!value) return;
		this.isTldDk = value.isValidDomainDk();
		this.loadDomainProducts();
	}

	set selectedVariant(value: ProductVariantModel | undefined) {
		this._selectedVariant = value;
		if (this.isTldDk) this.price = this._selectedVariant?.price;
	}
	get selectedVariant() { return this._selectedVariant; }

	get isValid() { return (this.price !== undefined || this.isTldDk) && !!this.selectedVariant?.id; }

	private _selectedVariant?: ProductVariantModel;
	private readonly productService = inject(ProductService);
	private readonly brandService = inject(BrandService);

	async loadDomainProducts() {
		const dkDomainTag = `${ProductPlanTagConstants.prefixForProductTags}${ProductPlanTagConstants.domainDk}`;
		const foreignDomainTag = `${ProductPlanTagConstants.prefixForProductTags}${ProductPlanTagConstants.domainForeign}`;

		const allProducts = await this.productService.getAllActiveProducts(false);
		const domainProducts = allProducts.filter(p => p.productTags.some(pt => pt.tag == (this.isTldDk ? dkDomainTag : foreignDomainTag)));
		const productVariants = this.productService.sortVariantsByPeriod(domainProducts.flatMap(p => p.productVariants));
		this.availableVariants = productVariants.map(variant => new SelectListItemModel(variant, this.productService.getVariantName(variant)));
		this.brands = this.brandService.brands.map(brand => new SelectListItemModel(brand.id!, brand.name));

		if (productVariants.length == 1) this.selectedVariant = productVariants[0];
	}
}
